import type { ReactNode } from 'react';
import type { Except } from 'type-fest';
import { Rotate } from './Transitions/Rotate';
import { SlideIn } from './Transitions/SlideIn';
import type { KittTransitionProps } from './Transitions/propTypes';
import { useMediaQuery } from './hooks/useMediaQuery';

interface TransitionProps extends Except<KittTransitionProps, 'children'> {
  children: ReactNode;
}

export function Transition({ children, ...props }: TransitionProps): ReactNode {
  const matches = useMediaQuery('(min-width: 480px)');
  return matches ? (
    <Rotate {...props}>{(): ReactNode => children}</Rotate>
  ) : (
    <SlideIn from="bottom" {...props}>
      {(): ReactNode => children}
    </SlideIn>
  );
}
